import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { CheckboxGroupFieldWUT } from '../../../ui/checkbox-group-field';
export const CheckboxGroupWUT = (props)=>{
    const { fieldType = FIELD_TYPES.CHECKBOX_GROUP } = props;
    return /*#__PURE__*/ React.createElement(CheckboxGroupFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=checkbox-group-wut.js.map